import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddMessagingTokenInUser1703492830803 implements MigrationInterface {
	name = 'AddMessagingTokenInUser1703492830803'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "user" ADD "messagingToken" json`)
		await queryRunner.query(
			`ALTER TABLE "table_token" ALTER COLUMN "token" SET DEFAULT substr(md5(''||now()::text||random()::text), 0, 16)`,
		)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(
			`ALTER TABLE "table_token" ALTER COLUMN "token" SET DEFAULT substr(md5(((''|| (now())) || (random()))), 0, 16)`,
		)
		await queryRunner.query(`ALTER TABLE "user" DROP COLUMN "messagingToken"`)
	}
}
